{
  "lastUpdatedAt": "2026-04-30T15:05:51.231Z",
  "lastFetchAttemptAt": "2026-04-30T15:05:51.231Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}